import axios from "axios"
import { API_BASE_URL } from "../config/api"
import { requestLocaleHeaders, translateError } from "../i18n"
import { getGameRechargeToken } from "../utils/gameRechargeSession"

const request = axios.create({
  baseURL: `${API_BASE_URL}/companion-game-wallet`,
  timeout: 30000,
  headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
  transformRequest: [data => {
    if (!data) return data
    const body = new URLSearchParams()
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) body.append(key, data[key])
    })
    return body
  }]
})

request.interceptors.request.use(config => {
  Object.assign(config.headers, requestLocaleHeaders())
  const token = getGameRechargeToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  config.skipAuthRedirect = true
  return config
})

request.interceptors.response.use(response => {
  const payload = response.data || {}
  if (Number(payload.code) === 200) return payload.data || {}
  const code = payload.error_code || payload.message_code || payload.msg || "COMMON.REQUEST_FAILED"
  const error = new Error(payload.error_detail || translateError(code))
  error.code = code
  throw error
}, error => {
  const payload = error.response && error.response.data
  if (payload) {
    const code = payload.error_code || payload.message_code || payload.msg || "COMMON.REQUEST_FAILED"
    error.code = code
    error.message = payload.error_detail || translateError(code)
  }
  return Promise.reject(error)
})

export const exchangeTicket = ticket => request.post("/ticket_exchange", { ticket })
export const getCheckoutSession = () => request.get("/session_get")
export const getGameWallet = () => request.get("/web_wallet_get")
export const getPaymentChannels = () => request.get("/channel_list_get")
export const getRechargeQuote = (channel, amountCny) => request.post("/web_recharge_quote", { channel, amount_cny: amountCny })
export const createRechargeOrder = payload => request.post("/web_recharge_order_create", payload)
export const getPaymentStatus = orderNo => request.get("/payment_status_get", { params: { order_no: orderNo } })
export const capturePayPal = orderNo => request.post("/paypal_capture", { order_no: orderNo })
export const capturePayPalPublic = (orderNo, captureToken) => request.post("/paypal_capture_public", { order_no: orderNo, capture_token: captureToken })
